import { useState, useEffect } from 'react';
import { DIRECTIONS, useDirection } from '@eti/providers';
import { DIRECTION } from '../constants';
import { get, set } from '../store/store';
import { buttonStyles } from '../styles/style';
import DirectionArrows from './DirectionArrows';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  LTR,
  RTL
} = DIRECTIONS;
const setDocumentDirection = direction => {
  document.documentElement.dir = direction;
  set(DIRECTION, direction);
};
const getOppositeDirection = direction => direction === LTR ? RTL : LTR;
const DirectionSwitchButton = ({
  text = 'Switch direction'
}) => {
  const {
    direction,
    setDirectionContext
  } = useDirection();
  const [currentDirection, setCurrentDirection] = useState(get(DIRECTION) || direction);
  useEffect(() => {
    setDirectionContext(currentDirection);
    setDocumentDirection(currentDirection);
    // oxlint-disable-next-line react/exhaustive-deps
  }, []);
  const handleClick = () => {
    const newDirection = getOppositeDirection(currentDirection);
    setCurrentDirection(newDirection);
    setDocumentDirection(newDirection);
    setDirectionContext(newDirection);
  };
  return /*#__PURE__*/_jsxs("button", {
    className: buttonStyles,
    onClick: handleClick,
    type: "button",
    children: [/*#__PURE__*/_jsx(DirectionArrows, {
      direction: currentDirection
    }), text]
  });
};
export default DirectionSwitchButton;
//# sourceMappingURL=DirectionSwitchButton.js.map